import React, { useContext, useState, useCallback, useMemo } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import Panel from '@prisjakt/ui-panel';
import PanelHeader from '@prisjakt/ui-panel-header';
import {
  SecondaryNavigationSlice as SecondaryNavigationSliceProps,
  ProductCollection,
} from '../../../../types';
import NavigationTabs from './tabs';
import NavigationLinks from './links';
import SitemapLink from './sitemap-link';

import * as S from './styles';

type Props = SecondaryNavigationSliceProps & {
  productCollection?: ProductCollection;
};

const SecondaryNavigationSlice = (props: Props) => {
  const { productCollection } = props;
  const groups = props.groups || [];
  const { t } = useContext(AppContext);
  const [currentGroup, setCurrentGroup] = useState(groups[0]?.property || '');
  const onTabClick = useCallback(group => setCurrentGroup(group), [
    setCurrentGroup,
  ]);
  const panelHeader = useMemo(
    () => (
      <PanelHeader
        divider="bottom"
        margin="top"
        title={t('category', 'product-collection.related-categories')}
      >
        <SitemapLink productCollection={productCollection} />
      </PanelHeader>
    ),
    [productCollection, t]
  );
  if (!props.groups?.length) {
    return null;
  }
  return (
    <S.Wrapper>
      <Panel header={panelHeader}>
        <S.HorizontalScroll>
          <NavigationTabs
            groups={groups}
            currentGroup={currentGroup}
            onClick={onTabClick}
          />
        </S.HorizontalScroll>
        <NavigationLinks groups={groups} currentGroup={currentGroup} />
      </Panel>
    </S.Wrapper>
  );
};

export default SecondaryNavigationSlice;
